import axios from "axios";
import store from "../store";
import config from "../config";

export const BaseUrl = "https://appcore.iranecar.com";
export const BaseUrl_New = "https://api." + config.staging + "iranecar.com/app";

const HTTP = axios.create({
  baseURL: BaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});
const HTTP_New = axios.create({
  baseURL: BaseUrl_New,
  headers: {
    "Content-Type": "application/json",
  },
});

export default {
  getUserCars() {
    return HTTP_New.get("/api/v1/Garage/GetAllUsersCars", {
      headers: {
        Authorization: "Bearer " + store.state.token,
      },
    });
  },
  generateCarFinesPaymentLink(amount, billId, paymentId, callbackUrl) {
    return HTTP_New.post(
      "/api/v1/Payment/CarFines",
      { amount, billId, paymentId, callbackUrl },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getViolationImageInquiry(userCarId, serialNo , uniqueID) {
    return HTTP_New.post(
      "/api/v1/Inquiry/ViolationImageInquiry",
      { userCarId: userCarId, serialNo: serialNo , uniqueID: uniqueID},
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getViolationImageInquiryByInfo(
    client,
    mobile,
    nationalCode,
    licensePlateIranDigits,
    licensePlateThreeDigits,
    licensePlateAlphabet,
    licensePlateFirstTwoDigits,
    code,
    serialNo ,
    uniqueID
  ) {
    return HTTP_New.post(
      "/api/v1/Inquiry/ViolationImageInquiryByInfo",
      {
        client,
        mobile,
        nationalCode,
        licensePlateIranDigits,
        licensePlateThreeDigits,
        licensePlateAlphabet,
        licensePlateFirstTwoDigits,
        code,
        serialNo ,
        uniqueID
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getViolationInquiry(client, CarUserId) {
    return HTTP_New.post(
      "/api/v1/Inquiry/ViolationInquiry",
      { client: client, userCarId: CarUserId },
      {
        headers: {
          // کدخدایی
          //'Authorization': "QQXWdkvSDgppDof9vugtpMaiKQF6ww6/wCHbS4EJTqpBAjwTFk+1nrhbhv7NCOduuHva7+Cw/M6l+8/K2KyduGXTkDhgQ0dVQQptPbv13HQDV3NqoE42gJJDUZru8j1DejyjyuTTnVOPStMWqd4KhYehnJ8MkBW7/w1dZg2ZXGSxfAgX1IKyXHfA4feV6QIps4bKxqWN/0PWSi9mfOqL5Q==",
          // محمدی
          //'Authorization': "8SeRHmYykNzgU6xL9Kx8LqccqQifvY2PiQWJFPWYdLAFU+4tIThE5Vu3hNqL6QWYMstqbJxbQzgUOSLdupVxH10h/82+PWIYkdLxMMt2flDl/V+xg7lNX9+Y0JkhK8q/k+D6TIAVVRlag7vaQU9GGJMzyXS24leoPMwhmU+jrNRv8PXS+HLKJk4V+kjkur8E1PkOmUf2ApdoNyvhx7h2yg==",
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getViolationInquiryByInfo(
    client,
    mobile,
    nationalCode,
    licensePlateIranDigits,
    licensePlateThreeDigits,
    licensePlateAlphabet,
    licensePlateFirstTwoDigits,
    code
  ) {
    return HTTP_New.post(
      "/api/v1/Inquiry/ViolationInquiryByInfo",
      {
        client,
        mobile,
        nationalCode,
        licensePlateIranDigits,
        licensePlateThreeDigits,
        licensePlateAlphabet,
        licensePlateFirstTwoDigits,
        code,
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getSendOtp(mobile) {
    return HTTP_New.post(
      "/api/v1/Inquiry/SendOtp",
      {
        mobile,
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getViolationInquiryAll(client, CarUserId) {
    return HTTP_New.post(
      "/api/v1/Inquiry/AccumulationViolationsInquiry",
      { client: client, userCarId: CarUserId },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getViolationInquiryAllByInfo(
    client,
    mobile,
    nationalCode,
    licensePlateIranDigits,
    licensePlateThreeDigits,
    licensePlateAlphabet,
    licensePlateFirstTwoDigits,
    code
  ) {
    return HTTP_New.post(
      "/api/v1/Inquiry/AccumulationViolationsInquiryByInfo",
      {
        client,
        mobile,
        nationalCode,
        licensePlateIranDigits,
        licensePlateThreeDigits,
        licensePlateAlphabet,
        licensePlateFirstTwoDigits,
        code,
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getCardSanadInquiry(client, CarUserId) {
    return HTTP_New.post(
      "/api/v1/Inquiry/CardSanadInquiry",
      { client: client, userCarId: CarUserId },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getCardSanadInquiryByInfo(
    client,
    mobile,
    nationalCode,
    licensePlateIranDigits,
    licensePlateThreeDigits,
    licensePlateAlphabet,
    licensePlateFirstTwoDigits,
    code
  ) {
    return HTTP_New.post(
      "/api/v1/Inquiry/CardSanadInquiryByInfo",
      {
        client,
        mobile,
        nationalCode,
        licensePlateIranDigits,
        licensePlateThreeDigits,
        licensePlateAlphabet,
        licensePlateFirstTwoDigits,
        code,
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getActivePlakInquiry(client, entity) {
    return HTTP_New.post(
      "/api/v1/Inquiry/ActivePlakInquiry?client=" + client,
      entity,
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getActivePlakInquiryByInfo(client, code, mobile, nationalCode) {
    return HTTP_New.post(
      "/api/v1/Inquiry/ActivePlakInquiryByInfo",
      {
        client,
        code,
        mobile,
        nationalCode,
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getLicenseStatusInquiry(client, entity) {
    return HTTP_New.post(
      "/api/v1/Inquiry/LicenseStatusInquiry?client=" + client,
      entity,
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getLicenseStatusInquiryByInfo(client, code, mobile, nationalCode) {
    return HTTP_New.post(
      "/api/v1/Inquiry/LicenseStatusInquiryByInfo",
      {
        client,
        code,
        mobile,
        nationalCode,
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getLicenseNegativePointInquiry(client, licenseNo) {
    return HTTP_New.post(
      "/api/v1/Inquiry/LicenseNegativePointInquiry",
      { client, licenseNo },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getLicenseNegativePointInquiryByInfo(
    client,
    code,
    mobile,
    nationalCode,
    licenseNo
  ) {
    return HTTP_New.post(
      "/api/v1/Inquiry/LicenseNegativePointInquiryByInfo",
      {
        client,
        code,
        mobile,
        nationalCode,
        licenseNo,
      },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getTehranTolls(carId) {
    return HTTP.post(
      "/api/v1/Inquiry/TehranTolls",
      { CarUserId: carId },
      {
        headers: {
          Authorization: store.state.token,
        },
      }
    );
  },
  getAirPollutions(carId) {
    return HTTP.post(
      "/api/v1/Inquiry/AirPollutions",
      { CarUserId: carId },
      {
        headers: {
          Authorization: store.state.token,
        },
      }
    );
  },
  getAnnualTolls(carId) {
    return HTTP.post(
      "/api/v1/Inquiry/AnnualTolls",
      { CarUserId: carId },
      {
        headers: {
          Authorization: store.state.token,
        },
      }
    );
  },
  getFreewayTolls(carId) {
    return HTTP.post(
      "/api/v1/Inquiry/FreewayTolls",
      { CarUserId: carId },
      {
        headers: {
          Authorization: store.state.token,
        },
      }
    );
  },
  saveBarcode(entity) {
    return HTTP.post("/api/v1/garage/saveBarcode", entity, {
      headers: {
        Authorization: store.state.token,
      },
    });
  },
  savePlate(entity) {
    return HTTP.post("/api/v1/garage/savePlate", entity, {
      headers: {
        Authorization: store.state.token,
      },
    });
  },
  saveVin(entity) {
    return HTTP.post("/api/v1/garage/saveVin", entity, {
      headers: {
        Authorization: store.state.token,
      },
    });
  },
  getTopUsers() {
    return HTTP.post(
      "/api/v1/club/getTopUsers",
      {},
      {
        headers: {
          Authorization: store.state.token,
        },
      }
    );
  },
  getVehicleExaminationCenters(options) {
    // var options = {
    //     "Title": null,
    //     "ProvinceId": null,
    //     "CityId": null,
    //     "PhoneNumber": null
    // };

    return HTTP.post(
      "/api/v1/car-service/GetVehicleExaminationCenters",
      options,
      {
        headers: {
          Authorization: store.state.token,
        },
      }
    );
  },
  getPlateReplacementCenters(options) {
    // var options = {
    //     "Title": null,
    //     "ProvinceId": null,
    //     "CityId": null,
    //     "PhoneNumber": null,
    //     "CurrentPage": 0
    //     "PageSize": 25
    // };

    return HTTP.post(
      "/api/v1/car-service/GetPlateReplacementCenters",
      options,
      {
        headers: {
          Authorization: store.state.token,
        },
      }
    );
  },
  getPetrolStations(options) {
    return HTTP.post("/api/v1/car-service/GetPetrolStations", options, {
      headers: {
        Authorization: store.state.token,
      },
    });
  },
  getCarPriceList(options) {
    return HTTP.post("/api/v1/car-service/GetCarPriceList", options, {
      headers: {
        Authorization: store.state.token,
      },
    });
  },
  getBrandList() {
    return HTTP_New.get("/api/v1/car-info/brand-list");
  },
  getCarListByBrandId(brandId) {
    return HTTP_New.get(
      "/api/v1/car-info/GetCarListByBrandId?brandId=" + brandId
    );
  },
  getCarPropertiesByCarId(carId) {
    return HTTP_New.get(
      "/api/v1/car-info/GetCarPropertiesByCarId?carId=" + carId
    );
  },
  getAllActiveBonus() {
    return HTTP_New.get("/api/v1/club/GetAllActiveBonus", {
      headers: {
        Authorization: "Bearer " + store.state.token,
      },
    });
  },
  getInfoUserBonus() {
    return HTTP_New.get("/api/v1/Club/GetInfoUserBonus", {
      headers: {
        Authorization: "Bearer " + store.state.token,
      },
    });
  },
  getBonusDetails(options) {
    return HTTP_New.get(
      "/api/v1/Club/GetBonusDetails?PageNo=" +
        options.PageNo +
        "&PageSize=" +
        options.PageSize +
        "&Type=" +
        options.Type,
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getUserInformation() {
    return HTTP_New.get("/api/v1/Identity/GetUserInfo", {
      headers: {
        Authorization: "Bearer " + store.state.token,
        //'Authorization': "mJ88sazWCRfzTU+ALiiDJTvKZT5csDV6+jDcsQF8rh9osZQpCw91DTKMv9MjPmOxtPZRLQG9kkpkOAyrazAaUPDCEKIGRtjCW4HwR2KBo9LNd9Uu28uR+usE1M4FRvWC0V7STHz8KKROV2zQrpUV42VuxhVVIhED2LR3DK5PWz99vQ/DcHJHyzlNGiOPOhj4E1tpr07dqgLhron0HuqILw==",
        //'Authorization': "QQXWdkvSDgppDof9vugtpMaiKQF6ww6/wCHbS4EJTqpBAjwTFk+1nrhbhv7NCOduuHva7+Cw/M6l+8/K2KyduGXTkDhgQ0dVQQptPbv13HQDV3NqoE42gJJDUZru8j1DejyjyuTTnVOPStMWqd4KhYehnJ8MkBW7/w1dZg2ZXGSxfAgX1IKyXHfA4feV6QIps4bKxqWN/0PWSi9mfOqL5Q==",
        //'Authorization': "SZolO3TSzGt0AT0U2zjRE/cgmD+14qYNz4U+tb03lu+HPcmVFZfFZid0OOM8UeUfe0p/1stmOwDFmD3V3/5yCFV5ZU0TswoDkFiCeslz3vOHh9ACoDNrpgroTsWcPWJzNYD+vG6XR3jB5LVGVicuzcQjqSzC+6eYTJKuktE3Yy1jeUUMG0MTmvvbTbvtFgJCvNhXPlKNq/aigBECjtK2tQ==",
      },
    });
  },
  getBonus(id) {
    return HTTP_New.get("/api/v1/Club/GetBonus?Id=" + id, {
      headers: {
        Authorization: "Bearer " + store.state.token,
      },
    });
  },
  usedBonusCode(bonusId) {
    return HTTP_New.post(
      "/api/v1/Club/UsedBonusCode",
      { bonusId },
      {
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );
  },
  getPlateAlphabet() {
    return HTTP_New.get("/api/v1/Garage/GetPlateAlphabet");
  },
};
